import showError from "helpers/showError";

// Uncaught errors (e.g. `throw new UserError(...)` from event handlers) are
// shown to the user as snackbars. Reporting to Rollbar is *not* done here:
// Rollbar's own captureUncaught / captureUnhandledRejections handle that (see
// public/index.html), and its checkIgnore skips user-facing errors.
function forwardError(event) {
  const error = event.error || event.reason;
  if (!error) return;
  // Cancelled actions are expected; keep them out of the console.
  if (error.isAbortError) event.preventDefault();
  showError(error);
}

export default function errorHandlePatch() {
  window.addEventListener("error", forwardError);
  window.addEventListener("unhandledrejection", forwardError);
}
